import { createSlice } from "@reduxjs/toolkit"
import { Noop, SimpleSelector, SimpleSetter } from "../utils"
import Axios, {
	AxiosInstance,
	InternalAxiosRequestConfig,
	Axios as AxiosType,
	AxiosError,
} from "axios"
import * as dotEnv from "lib/dotEnv"
import axios from "axios"

interface tokenState {
	token: string
	axiosInstance: AxiosInstance
	permissionError: string
}

const tokenState: tokenState = {
	axiosInstance: Axios.create({
		baseURL: dotEnv.Get("BASE_API_URL"),
		headers: {
			"Content-Type": "application/json",
			"Accept": "application/json",
		},
	}),
	token: "",
	permissionError: "",
}

function configHasHeaders(c: InternalAxiosRequestConfig<any>): bool {
	return !(c.headers.Authorization?.toString!() || "").IsEmpty()
	// !c.headers['Access-Control-Allow-Origin'].isEmpty() &&
	// !c.headers['Access-Control-Allow-Methods'].isEmpty()
}

export function SetupAxiosInterceptors(
	axiosInstance: AxiosType,
	token: string,
	handleTokenRefresh: () => void
) {
	const reqId = axiosInstance.interceptors.request.use(
		(config) => {
			if (!configHasHeaders(config)) {
				config.headers.Authorization = `Bearer ${token}`
				//config.headers['Access-Control-Allow-Origin'] = '*';
				// console.log('axios request submitted with token ', token);
			}
			return config
		},
		(err) => Promise.reject(err)
	)

	const respId = axiosInstance.interceptors.response.use(
		(resp) => resp,
		async (err) => {
			if (err.response?.status === 401) {
				log.Warn("401 error, refreshing token")
				handleTokenRefresh()
			}
			//Check if the error is a CancelError caused by API timeout
			if (axios.isCancel(err) && err.message === "canceled") {
				log.Errorf(
					"Request aborted due to timeout: %s",
					(err as AxiosError).config?.url || "Unknown URL"
				)
				// Update the error message
				err.message = "Request aborted due to timeout"
			}
			return Promise.reject(err)
		}
	)

	return () => {
		axiosInstance.interceptors.request.eject(reqId)
		axiosInstance.interceptors.response.eject(respId)
		log.Info("interceptors ejected")
	}
}

export const TokenSlice = createSlice({
	name: "token",
	initialState: tokenState,
	reducers: {
		setToken: SimpleSetter<tokenState, string>("token"),
		fetchToken: (state) => {
			state.permissionError = ""
		},
		setAxiosInstance: SimpleSetter<tokenState, AxiosInstance>("axiosInstance"),
		setPermissionError: SimpleSetter<tokenState, string>("permissionError"),
		setupAxiosInterceptors: Noop<void>(),
		noop: Noop<void>(),
	},
	selectors: {
		selectToken: (state) => state.token,
		selectAxios: (state) => state.axiosInstance,
		selectPermissionError: SimpleSelector<tokenState, "permissionError">("permissionError"),
	},
})
